import { Game, Category, Banner } from '../types';

export const categories: Category[] = [
  { id: 'action', name: 'Action' },
  { id: 'puzzle', name: 'Puzzle' },
  { id: 'racing', name: 'Racing' },
  { id: 'strategy', name: 'Strategy' },
];

export const banner: Banner = {
  isActive: false,
  title: "OXO PLAY",
  description: "All games for free and no install needed!\ncome and play right now!",
  imageUrl: "https://images.unsplash.com/photo-1538481199705-c710c4e965fc?w=500&q=80"
};

export const games: Game[] = [
  {
    id: 'zombie-attack',
    title: 'Zombie Attack',
    description: 'Are you ready to face the relentless hordes of zombies? Welcome to "Zombie Attack," an exhilarating 2D action shooting game!',
    thumbnails: [
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fzombie-attack%2Fzombie_attack_01.png?alt=media',
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fzombie-attack%2Fzombie_attack_02.png?alt=media',
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fzombie-attack%2Fzombie_attack_03.png?alt=media',
    ],
    icon: 'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fzombie-attack%2Fapp_icon_zombie_attack.png?alt=media&token=945d49b4-9608-4e5b-b53c-9cb879d77aab',
    category: 'action',
    url: 'https://zembie-attack.oxogl.gg/',
    developer: 'OXO',
    rating: 9.2,
    votes: 245678,
    releaseDate: 'August 2023',
    lastUpdated: 'January 2025'
  },
  {
    id: 'merge-coffee',
    title: 'Merge Coffee',
    description: 'Challenge yourself to an exciting coffee-making adventure! Combine same coffee types, serve customers, and race against time.',
    thumbnails: [
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fmerge-coffee%2Fmerge_coffee_01.png?alt=media',
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fmerge-coffee%2Fmerge_coffee_02.png?alt=media',
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fmerge-coffee%2Fmerge_coffee_03.png?alt=media&token=07e6b3ed-a995-4098-8769-8cf1262a4b62'
    ],
    icon: 'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fmerge-coffee%2Fapp_icon_merge-coffee.png?alt=media&token=95d3613e-1176-4a64-9688-a57842a28da3',
    category: 'puzzle',
    url: 'https://merge-coffee.oxogl.gg',
    developer: 'OXO',
    rating: 8.9,
    votes: 156789,
    releaseDate: 'January 2025',
    lastUpdated: 'January 2025'
  },
  {
    id: 'downhill-ski',
    title: 'Downhill Ski',
    description: 'Experience the most thrilling skiing adventure in this captivating skiing game. Glide through magnificent snow-covered mountains!',
    thumbnails: [
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fdownhill-ski%2Fdownhill_ski_01.png?alt=media&token=845f81d3-e65c-4cc7-93a5-6d6e902ccc4e',
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fdownhill-ski%2Fdownhill_ski_02.png?alt=media&token=ca8372f0-b544-4d9d-8e82-b43c24124dd4',
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fdownhill-ski%2Fdownhill_ski_03.png?alt=media&token=f863e178-939e-4a64-ac0e-28878c55a6bc'
    ],
    icon: 'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fdownhill-ski%2Fapp_icon_downhill-ski.png?alt=media&token=a995ae7e-03a0-45c6-b7ae-9ab186ac120c',
    category: 'action',
    url: 'https://downhill-ski.oxogl.gg/',
    developer: 'OXO',
    rating: 9.0,
    votes: 178345,
    releaseDate: 'August 2023',
    lastUpdated: 'August 2023'
  },
  {
    id: 'draw-a-line',
    title: 'Draw a Line',
    description: 'A creative and engaging puzzle game where you need to connect target objects by drawing lines and progress through each level.',
    thumbnails: [
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fdraw-a-line%2Fdraw_a_line_01.png?alt=media&token=f1a21b27-6cd4-4f80-aa18-2b73e5416d85',
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fdraw-a-line%2Fdraw_a_line_02.png?alt=media&token=49bf875c-8551-4734-9ad5-c131d4b6933c',
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fdraw-a-line%2Fdraw_a_line_03.png?alt=media&token=a18ba8a2-057a-4b32-9213-446baeaac021'
    ],
    icon: 'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fdraw-a-line%2Fapp_icon_draw_a_line.png?alt=media&token=2a6f97d9-df65-4804-aed9-421924d1c1d7',
    category: 'puzzle',
    url: 'https://draw-a-line.oxogl.gg/',
    developer: 'OXO',
    rating: 8.8,
    votes: 134567,
    releaseDate: 'August 2023',
    lastUpdated: 'February 2024'
  },
  {
    id: 'flight-sim',
    title: 'Flight Sim',
    description: 'Experience the exhilaration of guiding aircraft for a safe landing. Use sliding gestures to control aircraft direction and altitude.',
    thumbnails: [
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fflight-sim%2Fflight_sim_01.png?alt=media&token=9a090df5-9be4-484d-93be-7058a04ff638',
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fflight-sim%2Fflight_sim_02.png?alt=media&token=28fcea77-104d-492c-a26b-77bce086bc6b',
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fflight-sim%2Fflight_sim_03.png?alt=media&token=5720615e-20b8-4429-98fb-8748103a94d0'
    ],
    icon: 'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fflight-sim%2Fapp_icon_flight_sim.png?alt=media&token=b67778f9-3f8f-4852-bfc3-b78e049ab9ed',
    category: 'simulation',
    url: 'https://flight-sim.oxogl.gg/',
    developer: 'OXO',
    rating: 9.1,
    votes: 167890,
    releaseDate: 'August 2023',
    lastUpdated: 'August 2023'
  },
  {
    id: 'match-doodle',
    title: 'Match Doodle',
    description: 'A simple and enjoyable matching puzzle game that will immerse you in a colorful realm of doodles.',
    thumbnails: [
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fmatch-doodle%2Fmatch_doodle_01.png?alt=media&token=84ed5dc2-7aff-40d9-9445-926ce5ee9fa5',
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fmatch-doodle%2Fmatch_doodle_02.png?alt=media&token=898acbbd-265b-4513-806e-7b86ab7ea5e0',
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fmatch-doodle%2Fmatch_doodle_03.png?alt=media&token=5788fad0-733b-467b-bd76-62aa8353a76f'
    ],
    icon: 'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fmatch-doodle%2Fapp_icon_match_doodle.png?alt=media&token=334eb53f-4d87-4ce2-bec6-4386458249c0',
    category: 'puzzle',
    url: 'https://match-doodle.oxogl.gg/',
    developer: 'OXO',
    rating: 8.7,
    votes: 145678,
    releaseDate: 'August 2023',
    lastUpdated: 'November 2023'
  },
  {
    id: 'find-me',
    title: 'Find Me',
    description: 'Navigate through dynamic crowds to locate the hidden target player in this captivating puzzle adventure.',
    thumbnails: [
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Ffind-me%2Ffind_me_01.png?alt=media&token=84ed5dc2-7aff-40d9-9445-926ce5ee9fa5',
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Ffind-me%2Ffind_me_02.png?alt=media&token=898acbbd-265b-4513-806e-7b86ab7ea5e0',
      'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Ffind-me%2Ffind_me_03.png?alt=media&token=fb7d138b-bf14-47d2-852f-d66b8638d1e3'
    ],
    icon: 'https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Ffind-me%2Fapp_icon_find-me.png?alt=media&token=e05dff04-6bc4-4fa8-9809-9a614c14cd72',
    category: 'puzzle',
    url: 'https://find-me.oxogl.gg',
    developer: 'OXO',
    rating: 8.9,
    votes: 123456,
    releaseDate: 'November 2023',
    lastUpdated: 'November 2023'
  },
  {
    id: "avoid-missiles",
    title: "Avoid Missiles",
    description: "Test your reflexes and skills by dodging incoming missiles in this fast-paced action game.",
    thumbnails: [
      "https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Favoid-missiles%2Favoid-missiles_01.jpg?alt=media&token=912a8733-75d5-41b9-81c0-8e85be8c44a6",
      "https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Favoid-missiles%2Favoid-missiles_02.png?alt=media&token=4fa07e90-cb5f-4050-b6ff-0833e60e7b89",
      "https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Favoid-missiles%2Favoid-missiles_03.png?alt=media&token=627f4fd5-ca98-42a5-b3b4-de0993a64f51"
    ],
    icon: "https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Favoid-missiles%2Fapp_icon_avoid-missiles.png?alt=media&token=67dd7bb9-194b-4db6-a036-415dca0f323b",
    category: "action",
    url: "https://avoid-missiles.oxogl.gg/",
    developer: "OXO",
    rating: 9.0,
    votes: 150000,
    releaseDate: "January 2023",
    lastUpdated: "January 2023"
  },
  {
    id: "woodland-rotate",
    title: "Woodland Rotate",
    description: "Explore a magical woodland puzzle where you rotate pieces to create paths and solve challenging environmental puzzles.",
    thumbnails: [
      "https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fwoodland-rotate%2Fwoodland-rotate_01.png?alt=media&token=ccd741ae-a8b8-4589-bc5d-e8895e0b5d9d",
      "https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fwoodland-rotate%2Fwoodland-rotate_02.png?alt=media&token=430b8fd5-a88a-4a2b-8435-fc5f495e6950",
      "https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fwoodland-rotate%2Fwoodland-rotate_03.png?alt=media&token=25ed977b-1e58-418f-81a8-7bb65afb355c"
    ],
    icon: "https://firebasestorage.googleapis.com/v0/b/oxo-launcher.appspot.com/o/play%2Fwoodland-rotate%2Fapp_icon_woodland-rotate.png?alt=media&token=869101bd-9504-4b69-b694-fd136a53e6ff",
    category: "puzzle",
    url: "https://woodland-rotate.oxogl.gg/",
    developer: "OXO",
    rating: 8.8,
    votes: 142500,
    releaseDate: "March 2023",
    lastUpdated: "March 2023"
  }
];